import { writeBatch, WriteBatch } from "firebase/firestore";
import { db } from "../integrations/firebase/firestore";

type BatchOperation = (batch: WriteBatch) => void;

const MAX_OPERATIONS_PER_BATCH = 10;

export async function commitInBatches(
  operations: BatchOperation[],
  batchSize: number = MAX_OPERATIONS_PER_BATCH,
) {
  const batches = [];
  for (let i = 0; i < operations.length; i += batchSize) {
    const batch = writeBatch(db);
    operations.slice(i, i + batchSize).forEach((op) => op(batch));
    batches.push(batch);
  }
  await Promise.all(batches.map((batch) => batch.commit()));
}
